import React from 'react';
import ReactTooltip from 'react-tooltip';

import { ReactComponent as InfoIcon } from 'assets/icons/info.svg';

import styles from './WarningInfoIcon.module.css';

interface WarningInfoIconProps {
  message?: string;
  tooltipStyle?: any;
}

const WarningInfoIcon: React.FC<WarningInfoIconProps> = ({
  message = 'Cancelled due to deleted Practitioner',
  tooltipStyle,
}) => {
  const id = `${new Date().getMilliseconds()}`;

  return (
    <>
      <div data-for={id} data-tip="" className="w-fit cursor-pointer">
        <InfoIcon />
      </div>
      <ReactTooltip
        id={id}
        place="bottom"
        effect="solid"
        className={`${styles.wrapper} ${tooltipStyle && tooltipStyle}`}
      >
        <div className={styles.infoIconTooltip}>{message}</div>
      </ReactTooltip>
    </>
  );
};

export default WarningInfoIcon;
